export default __webpack_public_path__ + "static/media/4.0fc31c26.png";